(function($) {
    "use strict";

    /**
     * Equalize Heights of Cross-Sell Products
     */
    function equalizeHeights() {
        var slides = $('.cross-sells .loop-product');

        var totalSlides = slides.length;

        if (totalSlides > 0) {
            setHeights();
            return;
        }

        function setHeights() {
            // Reset heights to auto to recalculate correctly
            slides.css('height', 'auto');

            // Find the maximum height
            var maxHeight = 0;
            slides.each(function() {
                var currentHeight = $(this).outerHeight();
                if (currentHeight > maxHeight) {
                    maxHeight = currentHeight;
                }
            });

            // Set all .loop-product elements to the maximum height
            slides.css('height', maxHeight);
        }
    }

    // Run on document ready
    $(document).ready(function() {
        // Run on page load in case variations are pre-selected
        equalizeHeights();

        // Run when a variation is selected, with a slight delay to account for the slider loading
        $('.variations_form select').on('change', function() {
            // Introduce a slight delay to allow content to load
            setTimeout(function() {
                equalizeHeights();
            }, 1500); // Adjust the delay (in milliseconds) as needed
        });
    });

})(jQuery);
